<template>
  <div class="color-picker">
    <OwnStack
      v-for="color in colors"
      :key="color.value"
      el="button"
      class="color-picker__chip"
      :style="color.style"
      align="center"
      justify="center"
      @click="handleSelect(color.value)"
    >
      <PhCheck
        v-if="selected === color.value"
        class="generic-white"
        size="16"
      />
    </OwnStack>
  </div>
</template>
<script>
import { PhCheck } from 'phosphor-vue/dist/phosphor-vue.esm'

import { OwnStack } from '@/ui'

import { mapModel } from '@/utils/computed'

const colors = [
  '#54B636',
  '#1B05E4',
  '#6F3ADF',
  '#BA27C8',
  '#C0289F',
  '#2AC343',
  '#DFAB3A',
  '#C2D83A',
  '#4CA9CD',
  '#5ECEC4',
  '#9B9B9B',
  '#3F3F3F',
]

export default {
  name: 'AnnouncementColorPicker',
  components: { OwnStack, PhCheck },
  props: {
    /**
     * Form errors
     */
    errors: { type: Array, default: () => [] },

    /**
     * Selected color
     * @model
     */
    value: { type: String, default: null },
  },
  data() {
    return {
      colors: colors.map((value) => ({
        style: { backgroundColor: value },
        value,
      })),
    }
  },
  computed: {
    ...mapModel('selected'),
  },
  methods: {
    handleSelect(color) {
      const { selected } = this

      this.selected = color === selected ? null : color
    },
  },
}
</script>
<style lang="scss" scoped>
.color-picker {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 8px;

  &__chip {
    width: 45px;
    height: 45px;
    border-radius: 8px;
  }
}
</style>
